import { useState } from "react";
import { changePassword } from "../../../api/User";
import { toast } from "react-toastify";

export default function SetPassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPassword2, setNewPassword2] = useState("");

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showNew2, setShowNew2] = useState(false);

    const handleUpdatePassword = async () => {
        if (!oldPassword || !newPassword || !newPassword2) {
            toast.warning("Vui lòng điền đầy đủ thông tin mật khẩu", {
                position: "bottom-right",
            });
            return;
        }

        if (newPassword !== newPassword2) {
            toast.warning("Mật khẩu mới và xác nhận mật khẩu không khớp", {
                position: "bottom-right",
            });
            return;
        }

        try {
            await changePassword(oldPassword, newPassword, newPassword2);
            toast.success("Đổi mật khẩu thành công", {
                position: "bottom-right",
            });
            setOldPassword("");
            setNewPassword("");
            setNewPassword2("");
        } catch (error) {
            toast.error("Đổi mật khẩu thất bại. Vui lòng thử lại.", {
                position: "bottom-right",
            });
        }
    };

    return (
        <div className="MuiTabPanel-root styles_tab_panel__NZzZm">
            <form
                className="change-password"
                style={{ textAlign: "center", margin: "30px 0px" }}
                onSubmit={(e) => {
                    e.preventDefault();
                    handleUpdatePassword();
                }}
            >
                {/* Mật khẩu cũ */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled"
                        htmlFor="old_password"
                    >
                        Mật khẩu cũ
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root MuiFilledInput-underline MuiInputBase-formControl MuiInputBase-adornedEnd MuiFilledInput-adornedEnd">
                        <input
                            id="old_password"
                            type={showOld ? "text" : "password"}
                            className="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiFilledInput-inputAdornedEnd"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <div
                            className="MuiInputAdornment-root styles_btn__Z3SzE MuiInputAdornment-positionEnd MuiInputAdornment-filled"
                            onClick={() => setShowOld(!showOld)}
                            style={{ cursor: "pointer" }}
                        >
                            {(
                                !showOld ? (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}>
                                        <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"></path>
                                    </svg>
                                ) : (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"></path></svg>
                                )
                            )}
                        </div>
                    </div>
                </div>

                {/* Mật khẩu mới */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled"
                        htmlFor="new_password"
                    >
                        Mật khẩu mới
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root MuiFilledInput-underline MuiInputBase-formControl MuiInputBase-adornedEnd MuiFilledInput-adornedEnd">
                        <input
                            id="new_password"
                            type={showNew ? "text" : "password"}
                            className="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiFilledInput-inputAdornedEnd"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <div
                            className="MuiInputAdornment-root styles_btn__Z3SzE MuiInputAdornment-positionEnd MuiInputAdornment-filled"
                            onClick={() => setShowNew(!showNew)}
                            style={{ cursor: "pointer" }}
                        >
                            {(
                                !showNew ? (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}>
                                        <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"></path>
                                    </svg>
                                ) : (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"></path></svg>
                                )
                            )}
                        </div>
                    </div>
                </div>

                <div className="styles_error__niMJI"></div>

                {/* Nhập lại mật khẩu */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled"
                        htmlFor="new_password2"
                    >
                        Nhập lại mật khẩu mới
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root MuiFilledInput-underline MuiInputBase-formControl MuiInputBase-adornedEnd MuiFilledInput-adornedEnd">
                        <input
                            id="new_password2"
                            type={showNew2 ? "text" : "password"}
                            className="MuiInputBase-input MuiFilledInput-input MuiInputBase-inputAdornedEnd MuiFilledInput-inputAdornedEnd"
                            value={newPassword2}
                            onChange={(e) => setNewPassword2(e.target.value)}
                        />
                        <div
                            className="MuiInputAdornment-root styles_btn__Z3SzE MuiInputAdornment-positionEnd MuiInputAdornment-filled"
                            onClick={() => setShowNew2(!showNew2)}
                            style={{ cursor: "pointer" }}
                        >
                            {(
                                !showNew2 ? (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}>
                                        <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"></path>
                                    </svg>
                                ) : (
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "rgb(175, 175, 175)" }}><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"></path></svg>
                                )
                            )}

                        </div>
                    </div>
                </div>

                <div className="styles_error__niMJI"></div>

                <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "10px" }} />

                {/* Button */}
                <div style={{ margin: "30px 0px" }}>
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR my-order__button my-order__button--green bg-gradient"
                        type="submit"
                    >
                        <span className="MuiButton-label">Cập nhật</span>
                        <span className="MuiTouchRipple-root"></span>
                    </button>
                </div>
            </form>
        </div>
    );
}
